// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between', p: '24px 16px 0px', mt: 'auto' }}
    >
      <Typography variant="caption">&copy; {new Date().getFullYear()} Liance. Compliance work, kept moving.</Typography>
      <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between' }}>
        <Link href="mailto:hello@liance.dev" variant="caption" color="text.primary" underline="hover">
          Contact
        </Link>
        <Link href="https://liance.dev/privacy-policy" target="_blank" rel="noopener noreferrer" variant="caption" color="text.primary" underline="hover">
          Privacy
        </Link>
        <Link href="https://liance.dev/terms" target="_blank" rel="noopener noreferrer" variant="caption" color="text.primary" underline="hover">
          Terms
        </Link>
        <Link href="https://liance.dev/security" target="_blank" rel="noopener noreferrer" variant="caption" color="text.primary" underline="hover">
          Security
        </Link>
        <Link href="/status" variant="caption" color="text.primary" underline="hover">
          Status
        </Link>
      </Stack>
    </Stack>
  );
}
